import React from 'react';
import { connect } from 'react-redux';
import {createSelector} from 'reselect';
import { Link } from "react-router-dom";
import { Main } from '../../layout';
import { DocumentTitle } from '../../../helpers';
import { DonationForm } from '../Common';

class About extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false
        }
    }

    render() {
        const { loggedIn } = this.props.authentication;
        const { open } = this.state;

        console.log('openopen', open);

        return (<Main>
            <DocumentTitle title={`About Us`}/>
            <DonationForm open={open} handleClose={() => this.setState({open: false})} />
            <section className="about-page">
                <div className="about-banner">
                    <div className="image">
                       <img className="img-fluid" src="/images/about.png"/> 
                    </div>
                    <div className="caption">
                        <div className="container">
                             <h2 className="">Transform your life <br/>through<br/> K12 Tutor Connect</h2>
                             <p>
                                 K12 Tutor Connect was created by a teacher for teachers and parents. This online platform was created to bring teachers
                                  and parents together in one location in order  to further facilitate the learning of our most precious gift...OUR
                                   STUDENTS and CHILDREN.
                            </p>
                             {!loggedIn && <Link to="/login" className="btn btn-primary"> Get Started</Link>}
                        </div>
                    </div>
                </div>
                <div className="passion mb-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <img className="img-fluid" src="/images/svg/learn.svg" alt="Banner" />    
                            </div>
                            <div className="col-md-6 pt-4"> 
                                <h2>Find your perfect<br/> tutor</h2>
                                <p>We recruit tutors from all over  with vast amounts of knowledge in all areas.
                                </p>
                            </div> 
                        </div>
                    </div>
                </div>
                <div className="passion mb-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 text-center mx-auto"> 
                                <h2>Organize your course</h2>
                                <p>Tutors have the autonomy to organize their sessions as they see fit to best meet the needs of the student.
                                </p>
                                {!loggedIn && <Link to="/login" className="btn btn-primary"> Get Started</Link>}
                            </div> 
                        </div>
                    </div>
                </div>
                <div className="passion mb-5">
                    <div className="container">
                        <div className="row">
                            
                            <div className="col-md-5 mt-5"> 
                                <h2>Discover new <br/>experiences</h2>
                                <p>Use this platform to add to or build knowledge, in or outside the classroom.  We have a great selection of subjects to choose from!
                                </p>
                            </div> 
                            <div className="col-md-6">
                                <img className="img-fluid" src="/images/about-1.png" alt="Banner" />    
                            </div>
                        </div>
                    </div>
                </div> 
                <div className="passion mb-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 text-center mx-auto"> 
                                <h2>Want to help</h2>
                                <p>
                                Donate monetarily (any amount) to provide sessions to a less fortunate child through Stripe <button type="button" className="btn btn-link" onClick={() => this.setState({open: true})}>click here</button>
                                </p>
                                <Link to="/contact-us" className="btn btn-primary">Need Assistance</Link>
                            </div> 
                        </div>
                    </div>
                </div>   
            </section>
        </Main>);
    }
}

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const mapStateToProps = createSelector(
    authenticationSelector,

    (authentication) =>
        ({authentication})
);

export default connect(mapStateToProps)(About);
